var _a;
import { createSlice } from "@reduxjs/toolkit";
// Initial state
var initialState = {
    dashboardData: null,
};
// Slice
var manageTripsDashboardHeaderSlice = createSlice({
    name: "manageTripsDashboardHeader",
    initialState: initialState,
    reducers: {
        setDashboardHeaderData: function (state, action) {
            state.dashboardData = action.payload;
        },
        clearDashboardHeaderData: function (state) {
            state.dashboardData = null;
        },
    },
});
// Selectors
export var selectManageTripsDashboardHeaderData = function (state) { return state.manageTripsDashboardHeader.dashboardData; };
// Actions
export var setDashboardHeaderData = (_a = manageTripsDashboardHeaderSlice.actions, _a.setDashboardHeaderData), clearDashboardHeaderData = _a.clearDashboardHeaderData;
// Reducer
export default manageTripsDashboardHeaderSlice.reducer;
